import { Injectable, signal, effect } from '@angular/core';
import { ModalNames } from '../common/modal.config';

@Injectable({ providedIn: 'root' })
export class ModalService {
  modalsState = signal(new Map<ModalNames, boolean>());

  constructor() {
    window.addEventListener('popstate', () => {
      document.body.classList.remove('no-scroll');

      const resetMap = new Map<ModalNames, boolean>();
      for (const key of this.modalsState().keys()) {
        resetMap.set(key, false);
      }
      this.modalsState.set(resetMap);
    });
  }

  openModal(modalId: ModalNames): void {
    document.body.classList.add('no-scroll');
    if (window.matchMedia('(max-width: 767px)').matches) {
      window.scrollTo(0, 0);
    }
    const currentModals = new Map(this.modalsState());
    for (const key of currentModals.keys()) {
      currentModals.set(key, false);
    }
    currentModals.set(modalId, true);
    this.modalsState.set(currentModals);
  }

  closeModal(modalId: ModalNames): void {
    document.body.classList.remove('no-scroll');
    sessionStorage.removeItem('openModal');
    const currentModals = new Map(this.modalsState());
    if (currentModals.has(modalId)) {
      currentModals.set(modalId, false);
      this.modalsState.set(currentModals);
    }
  }

  toggleModal(closeModalId: ModalNames, openModalId: ModalNames): void {
    document.body.classList.toggle('no-scroll', openModalId !== closeModalId);
    const currentModals = new Map(this.modalsState());
    currentModals.set(closeModalId, false);
    currentModals.set(openModalId, true);
    this.modalsState.set(currentModals);
  }
}
